import i18n from "../i18n";

class IdentifierUtils {
  formatVin(value) {
    return String(value).toUpperCase().replace(/\W/g, '').substring(0, 17)
  }

  formatLicensePlate(value) {
    return String(value).toUpperCase().replace(/\W/g, '')
  }

  formatBicycode(value) {
    return String(value).toUpperCase().replace(/\W/g, '').substring(0, 14)
  }

  validateLicensePlate(input) {
    const oldLicensePlatesExp = new RegExp('^[A-Z]{2}\\s?[0-9]{3}\\s?[A-Z]{2}$');
    const newLicensePlatesExp = new RegExp('^\\d{1,4}\\s?[A-Z]{1,3}\\s?\\d{2}$');

    const upperInput = input.toUpperCase();
    let oldMatch = upperInput.match(oldLicensePlatesExp);
    let newMatch = upperInput.match(newLicensePlatesExp);

    // Vérifier pour les plaques anciennes
    if (oldMatch && oldMatch[0]) {
      if (!/[OUI]/.test(oldMatch[0])) {
        return oldMatch[0].replace(/\s/g, '');
      }
    }

    // Vérifier pour les nouvelles plaques
    if (newMatch && newMatch[0]) {
      if (!/[OUI]/.test(newMatch[0])) {
        return newMatch[0].replace(/\s/g, '');
      }
    }

    return null; // Aucune correspondance valide trouvée
  }

  validVinFormat(input) {
    const formatVinExp = new RegExp('^[a-zA-Z0-9]{17}$');

    const upperInput = input.toUpperCase();
    let match = upperInput.match(formatVinExp);

    if (match && match[0]) {
      if (!/[OQI]/.test(match[0])) {
        return match[0].replace(/\s/g, '');
      }
    }

    return null;
  }

  validBicycodeFormat(input) {
    const formatBicycodeExp = new RegExp('^[a-zA-Z0-9]{10,14}$');

    const upperInput = input.toUpperCase();
    let match = upperInput.match(formatBicycodeExp);

    if (match && match[0]) {
      return match[0].replace(/\s/g, '');
    }

    return null;
  }

  getIdentifierInvalidFormatFeedback(identifier){
    switch (identifier) {
      case 'LICENCE_PLATE': return i18n.t('licence.plate.invalid.format', ['O, U, I'])
      default: return i18n.t('invalid.format')
    }
  }
}

export default new IdentifierUtils()



// WEBPACK FOOTER //
// ./src/utils/IdentifierUtils.js